interface IProps {
}

export const LandingHeader = (props: IProps) => {

    const userName = (window as any).investorName ? (window as any).investorName : '0';
    const userEmail = (window as any).investorEmail ? (window as any).investorEmail : '0';

    return (
        <div className="tc-landing-header">
            <div className="tc-landing-header-container acc-container">
                <div className="tc-landing-header-back-button">
                    <div className="tc-landing-header-back-icon"
                         onClick={() => {
                             let defaultLink = window.location.origin + "/accenture";
                             window.location.href = (window as any).homeLink === '' ? defaultLink : (window as any).homeLink;
                         }}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17" fill="none">
                            <path
                                d="M16 8.66682C16 8.84362 15.9298 9.01319 15.8047 9.13821C15.6797 9.26323 15.5102 9.33346 15.3334 9.33346H2.27628L7.13862 14.195C7.20056 14.2569 7.24969 14.3304 7.28322 14.4114C7.31674 14.4923 7.33399 14.579 7.33399 14.6666C7.33399 14.7542 7.31674 14.841 7.28322 14.9219C7.24969 15.0028 7.20056 15.0763 7.13862 15.1383C7.07669 15.2002 7.00315 15.2493 6.92223 15.2829C6.8413 15.3164 6.75457 15.3336 6.66697 15.3336C6.57938 15.3336 6.49264 15.3164 6.41172 15.2829C6.33079 15.2493 6.25726 15.2002 6.19532 15.1383L0.195518 9.13847C0.133536 9.07656 0.0843647 9.00303 0.0508163 8.9221C0.0172679 8.84117 0 8.75443 0 8.66682C0 8.57921 0.0172679 8.49246 0.0508163 8.41153C0.0843647 8.3306 0.133536 8.25708 0.195518 8.19517L6.19532 2.19536C6.32041 2.07027 6.49007 2 6.66697 2C6.84388 2 7.01353 2.07027 7.13862 2.19536C7.26371 2.32045 7.33399 2.49011 7.33399 2.66702C7.33399 2.84392 7.26371 3.01358 7.13862 3.13867L2.27628 8.00017H15.3334C15.5102 8.00017 15.6797 8.07041 15.8047 8.19543C15.9298 8.32045 16 8.49001 16 8.66682Z"
                                fill="white"/>
                        </svg>
                    </div>
                    <div onClick={() => {
                        let defaultLink = window.location.origin + "/accenture";
                        window.location.href = (window as any).homeLink === '' ? defaultLink : (window as any).homeLink;
                    }} className="tc-landing-header-home-text">
                        Home
                    </div>
                </div>

                <div className="tc-landing-header-user-details">
                    <div className="user-details">
                        <p className="user-name">{userName}</p>
                        <p className="user-email">{userEmail}</p>
                    </div>
                    <div className="user-image">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 24 24"
                            version="1.1"
                        >
                            <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                                <polygon points="0 0 24 0 24 24 0 24"/>
                                <path
                                    d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z"
                                    fill="#ffff"
                                    fillRule="nonzero"
                                    opacity="0.3"
                                />
                                <path
                                    d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z"
                                    fill="#ffff"
                                    fillRule="nonzero"
                                />
                            </g>
                        </svg>

                    </div>
                </div>
            </div>
        </div>
    );
}
